'use strict';

var TNBannerGridSlider = (function () {

  var AUTO_DELAY = 5000;

  var _initialised = {};

  function init(sectionId) {

    if (_initialised[sectionId]) return;
    _initialised[sectionId] = true;

    var wrap    = document.getElementById('tnbg-wrap-' + sectionId);
    var track   = document.getElementById('tnbg-track-' + sectionId);
    var prevBtn = document.getElementById('tnbg-prev-' + sectionId);
    var nextBtn = document.getElementById('tnbg-next-' + sectionId);
    var dotsEl  = document.getElementById('tnbg-dots-' + sectionId);

    if (!wrap || !track) return;

    var totalSlides    = parseInt(wrap.dataset.totalSlides, 10) || 1;
    var transitionMode = (wrap.dataset.transition || 'slide').toLowerCase();
    var slideEls        = track.querySelectorAll('.tnbg-slide');
    var currentSlide = 0;
    var touchStartX  = 0;
    var touchStartY  = 0;
    var didSwipe     = false;
    var autoTimer    = null;

    function stopAutoSlide() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    function startAutoSlide() {
      stopAutoSlide();
      if (totalSlides <= 1) return;
      autoTimer = setInterval(function () {
        var next = currentSlide + 1 >= totalSlides ? 0 : currentSlide + 1;
        goToSlide(next);
      }, AUTO_DELAY);
    }

    function updateDots() {
      if (!dotsEl) return;
      dotsEl.querySelectorAll('.tnbg-dot').forEach(function (dot, i) {
        var active = i === currentSlide;
        dot.classList.toggle('tnbg-dot--active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var atStart = currentSlide === 0;
      var atEnd   = currentSlide === totalSlides - 1;
      prevBtn.style.opacity       = atStart ? '0.35' : '1';
      prevBtn.style.pointerEvents = atStart ? 'none'  : '';
      nextBtn.style.opacity       = atEnd   ? '0.35' : '1';
      nextBtn.style.pointerEvents = atEnd   ? 'none'  : '';
    }

    function goToSlide(index) {
      if (index < 0 || index >= totalSlides) return;
      currentSlide = index;

      if (transitionMode === 'fade') {
        slideEls.forEach(function (slide, i) {
          slide.classList.toggle('tnbg-slide--active', i === currentSlide);
        });
      } else {
        track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
      }

      updateDots();
      updateArrows();
    }

    /* Sync active state on load (first slide already marked active in markup,
       but this guarantees consistency if currentSlide is ever reset). */
    if (transitionMode === 'fade') {
      slideEls.forEach(function (slide, i) {
        slide.classList.toggle('tnbg-slide--active', i === currentSlide);
      });
    }

    updateArrows();

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        stopAutoSlide();
        goToSlide(currentSlide === 0 ? totalSlides - 1 : currentSlide - 1);
        startAutoSlide();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        stopAutoSlide();
        goToSlide(currentSlide + 1 >= totalSlides ? 0 : currentSlide + 1);
        startAutoSlide();
      });
    }

    if (dotsEl) {
      dotsEl.querySelectorAll('.tnbg-dot').forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          stopAutoSlide();
          goToSlide(parseInt(dot.dataset.index, 10));
          startAutoSlide();
        });
      });
    }

    wrap.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
      didSwipe    = false;
      stopAutoSlide();
    }, { passive: true });

    wrap.addEventListener('touchend', function (e) {
      var dx = touchStartX - e.changedTouches[0].clientX;
      var dy = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) {
        didSwipe = true;
        var next = dx > 0 ? currentSlide + 1 : currentSlide - 1;
        if (next < 0) next = totalSlides - 1;
        if (next >= totalSlides) next = 0;
        goToSlide(next);
      }
      startAutoSlide();
    }, { passive: true });

    wrap.addEventListener('mouseenter', stopAutoSlide);
    wrap.addEventListener('mouseleave', startAutoSlide);

    startAutoSlide();
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="tnbg-wrap-"]').forEach(function (el) {
    var sectionId = el.id.replace('tnbg-wrap-', '');
    TNBannerGridSlider.init(sectionId);
  });
});